import {  CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface AGRDeactivateComponent {
    canExit: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const UnsavedFormGuard: CanDeactivateFn<AGRDeactivateComponent> = (component) => {
    
    return component.canExit ? component.canExit() : true;
    
};
